import React, { useEffect } from "react";
import { Box } from "@mui/material";
import PageHeader from "./PageHeader";
import { usePageTitle } from "context/PageTitleContext";

// Standard page shell. The page title is published to the top header bar (via
// PageTitleContext) rather than rendered in the body, so the header space is
// used. Subtitle, breadcrumbs and actions still render at the top of content.
const PageContainer = ({
  title,
  subtitle,
  breadcrumbs,
  actions,
  children,
  maxWidth = 1400,
}) => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle(title || "");
    return () => setTitle("");
  }, [title, setTitle]);

  const hasHeader =
    subtitle || actions || (breadcrumbs && breadcrumbs.length > 0);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, mx: "auto", maxWidth }}>
      {hasHeader && (
        <PageHeader
          subtitle={subtitle}
          breadcrumbs={breadcrumbs}
          actions={actions}
        />
      )}
      {children}
    </Box>
  );
};

export default PageContainer;
